// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3_yId","notes":"Notes_notes__3yKEy","note":"Notes_note__1Mtbk","markdown":"Notes_markdown__tKMlS"};